export default __webpack_public_path__ + "static/media/5.478f7540.png";